import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { OrgCommonFontsAndColorsPageComponent } from "./org-common-fonts-and-colors-page.component";

export const orgCommonFontsAndColorsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-org-common-fonts-and-colors-page", OrgCommonFontsAndColorsPageComponent)
    .atUrl("/about/theme-test/org-common-fonts-and-colors")
    .requiresLogin(false)
    .build();
